import { createApp } from "vue";
import { createVuetify } from "vuetify";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import "@mdi/font/css/materialdesignicons.css";
import { loadFonts } from "./plugins/webfontloader";
import "./assets/globalstyle.css";

loadFonts();

export default createVuetify({
  icons: {
    iconfont: "mdi", // Use MDI Icons
  },
  // You can customize Vuetify options here
});

createApp(App).use(router).use(vuetify).mount("#app");
